var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bt_menu",
    transform: "translate(-10.467 -15.467)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2109",
    "data-name": "Rectangle 2109",
    width: 5,
    height: 5,
    rx: 1,
    transform: "translate(10.467 15.467)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2114",
    "data-name": "Rectangle 2114",
    width: 5,
    height: 5,
    rx: 1,
    transform: "translate(10.467 22.467)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2117",
    "data-name": "Rectangle 2117",
    width: 5,
    height: 5,
    rx: 1,
    transform: "translate(10.467 29.467)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2110",
    "data-name": "Rectangle 2110",
    width: 5,
    height: 5,
    rx: 1,
    transform: "translate(17.467 15.467)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2113",
    "data-name": "Rectangle 2113",
    width: 5,
    height: 5,
    rx: 1,
    transform: "translate(17.467 22.467)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2116",
    "data-name": "Rectangle 2116",
    width: 5,
    height: 5,
    rx: 1,
    transform: "translate(17.467 29.467)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2111",
    "data-name": "Rectangle 2111",
    width: 5,
    height: 5,
    rx: 1,
    transform: "translate(24.467 15.467)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2112",
    "data-name": "Rectangle 2112",
    width: 5,
    height: 5,
    rx: 1,
    transform: "translate(24.467 22.467)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2115",
    "data-name": "Rectangle 2115",
    width: 5,
    height: 5,
    rx: 1,
    transform: "translate(24.467 29.467)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMenu);
export default __webpack_public_path__ + "static/media/ic_menu.9b14964e83192e99530069988aa48919.svg";
export { ForwardRef as ReactComponent };